import axios from 'axios';

//const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';
import api from './authService.js'

class UsuariosService {
  constructor() {
    /*
    this.api = axios.create({
      baseURL: `${API_URL}/usuarios`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    */
    this.api = api;

    // Interceptor para agregar el token de autenticación
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    // Interceptor para manejar errores
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  // Obtener todos los usuarios
  async getUsuarios() {
    try {
      const response = await this.api.get('/usuarios');
      return response.data;
    } catch (error) {
      console.error('Error obteniendo usuarios:', error);
      throw error;
    }
  }

  // Obtener usuario por ID
  async getUsuario(id) {
    try {
      const response = await this.api.get(`/usuarios/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo usuario:', error);
      throw error;
    }
  }

  // Crear nuevo usuario
  async createUsuario(usuario) {
    try {
      const response = await this.api.post('/usuarios', usuario);
      return response.data;
    } catch (error) {
      console.error('Error creando usuario:', error);
      throw error;
    }
  }

  // Actualizar usuario
  async updateUsuario(id, usuario) {
    try {
      const response = await this.api.put(`/usuarios/${id}`, usuario);
      return response.data;
    } catch (error) {
      console.error('Error actualizando usuario:', error);
      throw error;
    }
  }

  // Eliminar usuario
  async deleteUsuario(id) {
    try {
      const response = await this.api.delete(`/usuarios/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error eliminando usuario:', error);
      throw error;
    }
  }

  // Obtener permisos disponibles
  async getPermisosDisponibles() {
    try {
      const response = await this.api.get('/permisos/disponibles');
      return response.data;
    } catch (error) {
      console.error('Error obteniendo permisos:', error);
      throw error;
    }
  }
}

export default new UsuariosService(); 